import React, { useEffect, useState } from 'react';
import ButtonUI from '../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { translate } from '../../../utils/util';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { Select } from '../../../components/UI/ComponentsUI';

const SupplierModal = (props) => {
    const initialValues = {
        supplier: undefined
    }
    const [model, setModel] = useState(initialValues);

    useEffect(() => {
        return () => {
            if (props.onClose) {
                props.onClose();
            }
            setModel(initialValues);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        return () => {
            setModel(initialValues);
        }
        // eslint-disable-next-line
    }, [props.open]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <Modal
            style={{ marginTop: '100px' }}
            options={{
                dismissible: false
            }}
            open={props.open}
            id={props.lotItemId || 'ModalQuantityClosed'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={() => props.onConfirm(model.supplier)} text={props.btnConfirm ? props.btnConfirm : translate('confirm', 'general')} />
                </Row>
            }
        >
            <div>
                {props.open &&
                    <>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="title col s12">{translate('duplicate-invoice', 'physical-confirmation')}</span>
                                <span className="col s12">{translate('duplicate-invoice-text', 'physical-confirmation')}</span>
                            </div>
                        </Row>
                        <div id="formInput" className="row" style={{ marginBottom: '0px' }}>
                            <div className="padding col s12">
                                <Select
                                    required
                                    id="supplier"
                                    name="supplier"
                                    label={translate('supplier', 'physical-confirmation')}
                                    placeHolder={translate('choose-one-option', 'general')}
                                    data={props.data}
                                    defaultValue={model.supplier}
                                    change={onChange}
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
        </Modal>
    )
}

export default SupplierModal;
